/* eslint-disable no-new */
import { withProps } from 'recompose';

import mapPin from 'assets/images/map/maps-pin-blue.png';
import Marker from './Marker';

export const enhance = withProps(
	({ google, image }) => ({
		icon: new google.maps.MarkerImage(
			image || mapPin,
			new google.maps.Size(30, 42),
			new google.maps.Point(0, 0),
			new google.maps.Point(15, 42)
		)
	})
);


export default enhance(Marker);
